import React, { lazy } from "react";
// Project pages

const Home = lazy(() => import("./newPages/home/container"));
const LoginPage = lazy(() => import("./pages/auth/login"));
const SignVerify = lazy(() => import("./pages/auth/signVerify"));
const SignInWithPassword = lazy(
  () => import("./pages/auth/signInWithPassword")
);
const ForgetPassword = lazy(() => import("./pages/auth/forgetPassword"));
const SetPassword = lazy(() => import("./pages/auth/setPassword"));
const Finance = lazy(() => import("./pages/analytics/Finance"));
const Order = lazy(() => import("./pages/analytics/order"));
const OneOrderType = lazy(() => import("./pages/analytics/OneOrderType"));
const Kanban = lazy(() => import("./pages/orders/orderListKanban"));
const KanbanColumnEdit = lazy(
  () => import("./pages/orders/orderListKanbanColumnEdit")
);
const OrderList = lazy(() => import("./pages/orders/orderListTable"));
const OrderInfo = lazy(() => import("./pages/orders/orderInfo"));
const OrderTableInfo = lazy(() => import("./modules/orders/components/orderList/orderInfo"));
const ComeOrders = lazy(() => import("./pages/orders/comeOrders"));
const NewStudentList = lazy(() => import("./pages/orders/newStudentList"));
const Attendance = lazy(() => import("./pages/students/attendance"));
const Activ = lazy(() => import("./pages/students/activ"));
const Arxiv = lazy(() => import("./pages/students/archive"));
const ComingSameDayOfWeek = lazy(
  () => import("./pages/students/comingSameDayOfWeek")
);
const Parents = lazy(() => import("./pages/students/parents"));
const Groups = lazy(() => import("./pages/group/groupsPage"));
const GroupTasks = lazy(() => import("./modules/group/container/tasks/tasks"));
const GroupTaskAnswers = lazy(
  () => import("./modules/group/container/tasks/taskAnswers")
);
const GroupsTemplate = lazy(() => import("./pages/group/groupTemplate"));
const GroupDetails = lazy(() => import("./pages/group/groupDetailPage"));
const GroupStudentsTemplate = lazy(
  () => import("./pages/group/groupStudentsTemplate")
);
const AttendanceGroup = lazy(() => import("./pages/group/attendancePage"));
const HistoryGroup = lazy(() => import("./pages/group/historyPage"));
const TimeTable = lazy(() => import("./pages/group/timeTablePage"));
const Rooms = lazy(() => import("./pages/group/roomsPage"));
const StudentList = lazy(() => import("./pages/students/studentList"));
const StudentsTemplate = lazy(
  () => import("./pages/students/StudentsTemplate")
);
const StudentHistory = lazy(() => import("./pages/students/StudentHistory"));
const StudentBalanceHistory = lazy(
  () => import("./modules/students/container/StudentBalanceHistory")
);
const Details = lazy(() => import("./pages/students/details"));
const CourseList = lazy(() => import("./pages/courses/courseList"));
const CoursesTemplate = lazy(() => import("./pages/courses/coursesTemplate"));
const AddCourse = lazy(() => import("./pages/courses/addCourse"));
const CourseDetails = lazy(() => import("./pages/courses/courseDetails"));
const AddLevel = lazy(() => import("./pages/courses/addLevel"));
const SectionsPage = lazy(() => import("./pages/courses/sections"));
const SettingSystem = lazy(() => import("./pages/settings/system"));
const AddBranch = lazy(
  () => import("./modules/hr/components/branches/addBranch")
);
const BranchsTemplate = lazy(
  () => import("./modules/settings/components/system/branches/branchesTemplate")
);
const SettingsFinance = lazy(() => import("./pages/settings/finance"));
const Study = lazy(() => import("./pages/settings/study"));
const SettingManagement = lazy(() => import("./pages/settings/management"));
const SaleMarketing = lazy(() => import("./pages/settings/saleMarketing"));
const SmsDevices = lazy(
  () => import("./modules/settings/components/smsDevices/SmsDevices")
);

const Shifts = lazy(() => import("./pages/shifts/shifts"));
const ShiftsHistory = lazy(() => import("./pages/shifts/shiftsHistory"));
const CheckHistory = lazy(() => import("./pages/shifts/checkHistory"));
const Management = lazy(() => import("./pages/shifts/management"));
const PaymentType = lazy(() => import("./pages/finance/PaymentType"));
const PaymentTypeAdd = lazy(() => import("./pages/finance/AddEditPaymentType"));
const PageNotFound = lazy(() => import("./pages/404/404"));
const Hr = lazy(() => import("./pages/hr/hrList"));
const EmployeeRatings = lazy(() => import("./modules/employeeRating"));
const EmployeesTemplate = lazy(() => import("./pages/hr/EmployeesTemplate"));
const Profile = lazy(() => import("./pages/hr/profile"));
const Branches = lazy(() => import("./modules/hr/container/branches"));
const Roles = lazy(() => import("./pages/hr/roles"));
const AddRoles = lazy(() => import("./pages/hr/addRoles"));
const News = lazy(() => import("./pages/news/news"));
const AddNews = lazy(() => import("./pages/news/addNews"));
const SmsTemplate = lazy(() => import("./pages/news/smsTemplate"));
const FinanceCash = lazy(() => import("./pages/finance/FinanceCash"));
const Surveys = lazy(() => import("./pages/marketing/Surveys"));
const MarketingForm = lazy(() => import("./modules/marketing/form/list/Form"));
const AddEditMarketingForm = lazy(
  () => import("./modules/marketing/form/addEdit/container/AddEdit")
);
const SurveysTemplate = lazy(() => import("./pages/marketing/SurveysTemplate"));
const Chat = lazy(() => import("./newPages/chat/container"));
const SectionList = lazy(
  () => import("./newPages/course/sections/list/container")
);
// const WorkSpace = lazy(() => import("./pages/tasks/WorkSpace"));
const Integration = lazy(() => import("./pages/settings/integration"));
const Transactions = lazy(() => import("./pages/settings/transactions"));
const Sms = lazy(
  () => import("./newPages/settings/integrations/sms/container")
);

const Products = lazy(() => import("./newPages/gamification/products"));
const Reasons = lazy(() => import("./newPages/gamification/reasons"));
const Categories = lazy(() => import("./newPages/gamification/categories"));
const Orders = lazy(() => import("./newPages/gamification/orders"));
const RankingList = lazy(() => import("./newPages/gamification/rankingList"));
const CoinSettings = lazy(() => import("./newPages/gamification/coinSettings"));

const SeasonalAssessment = lazy(() => import("./newPages/seasonal-assessment"));
const AddSeasonalAssessment = lazy(() => import("./newPages/seasonal-assessment/components/Add/Add"));

const Test = lazy(() => import("./newPages/test"));
const TestLevel = lazy(() => import("./newPages/test-level"));


const Bonus = lazy(() => import("./newPages/bonus/container"));
const KommoIntegration = lazy(() => import("./newPages/kommoIntegration"));
const Penalty = lazy(() => import("./modules/finance/penalty/container"));
const Invoice = lazy(() => import("./modules/finance/invoice/Invoice"));
const Feedback = lazy(() => import("./newPages/feedback/container"));
const ActiveSession = lazy(() => import("./newPages/session/SessionComponent"));
const NotificationFunction = lazy(
  () => import("./newPages/notifications/notifications")
);


const AddEditThirdPerson = lazy(
  () =>
    import(
      "./modules/settings/components/thirdpersons/addEdit/AddEditThirdPerson"
    )
);
const Contract = lazy(() => import("./pages/finance/Contract"));

const RepeaTableExpences = lazy(
  () =>
    import("./modules/finance/repeaTableExpences/container/RepeaTableExpences")
);
const TeacherAnaliticsDetails = lazy(
  () =>
    import(
      "./modules/analytics/containers/teacherAnalyticsDetails/TeacherAnalyticsDetails"
    )
);
const Salary = lazy(
  () => import("./modules/finance/salaryHistory/container/Salary")
);
const Balance = lazy(() => import("./modules/finance/balance"));
const SalaryCreate = lazy(() => import("./modules/finance/salaryCreate"));
const SalaryTransaction = lazy(
  () => import("./modules/finance/salaryTransacrion/SalaryTransaction")
);

const TeacherAnalitics = lazy(
  () => import("./pages/analytics/TeacherAnalitics")
);
const TasksList = lazy(() => import("./modules/employeeTask"));
const TasksTypeList = lazy(() => import("./modules/tasksType"));

const TasksSettings = lazy(
  () => import("./newPages/tasks/taskSettings/container")
);

const Questionnaire = lazy(() => import("./pages/analytics/Questionnaire"));
const Moderator = lazy(
  () => import("./modules/analytics/containers/moderator/container/Moderator")
);
const ModeratorDetails = lazy(
  () =>
    import("./modules/analytics/containers/moderator/details/ModeratorDetails")
);
const StudentByCourse = lazy(
  () =>
    import(
      "./modules/analytics/containers/studentCourse/container/StudentByCourse"
    )
);
const StudentByCourseDetails = lazy(
  () =>
    import(
      "./modules/analytics/containers/studentCourse/details/StudentByCourseDetails"
    )
);
const OrderByCourse = lazy(
  () =>
    import("./modules/analytics/containers/orderCourse/container/OrderByCourse")
);
const OrderByCourseDetails = lazy(
  () =>
    import(
      "./modules/analytics/containers/orderCourse/details/OrderByCourseDetails"
    )
);
const OrderModerator = lazy(
  () =>
    import(
      "./modules/analytics/containers/orderModerator/container/OrderModerator"
    )
);
const OrderModeratorDetails = lazy(
  () =>
    import(
      "./modules/analytics/containers/orderModerator/details/OrderModeratorDetails"
    )
);
const QuestionnaireDetails = lazy(
  () =>
    import(
      "./modules/analytics/containers/questionnaire/details/QuestionnaireDetails"
    )
);
const AnalyticsLinks = lazy(
  () => import("./modules/analytics/containers/analyticsLinks/AnalyticsLinks")
);
const BalanceAnalytics = lazy(
  () => import("./modules/analytics/containers/balance/Balance")
);
const CashflowAnalytics = lazy(
  () => import("./modules/analytics/containers/cashflow/Cashflow")
);
const ProfitLossAnalytics = lazy(
  () => import("./modules/analytics/containers/profitLoss/ProfitLoss")
);

const GroupStudents = lazy(
  () => import("./modules/group/container/groupStudent/GroupStudentContainer")
);

const AttendancesViewing = lazy(
  () => import("./modules/students/container/AttendancesViewing")
);
const GroupStudentCalculator = lazy(
  () =>
    import(
      "./modules/group/container/studentCalculatorContainer/StudentCalculatorContainer"
    )
);
const TaskAnswerByTeacher = lazy(
  () =>
    import(
      "./modules/analytics/containers/taskAnswerByTeacher/TaskAnswerByTeacher"
    )
);
const CancelledTransactions = lazy(
  () =>
    import(
      "./modules/analytics/containers/cancelledTransactions/CancelledTransactions"
    )
);

const GeneralDiscounts = lazy(() =>
    import(
      "./modules/analytics/containers/generalDiscounts/GeneralDiscounts"
    ))

const LeftReasons = lazy(
  () => import("./modules/analytics/containers/leftReasons/LeftReasons")
);

const IncomePlan = lazy(
  () => import("./modules/analytics/containers/incomePlan/IncomePlan")
);
const NotAttended = lazy(
  () => import("./modules/analytics/containers/notAttended/NotAttended")
);
const AttendanceAnalytics = lazy(
  () => import("./modules/analytics/containers/attendance/Attendance")
);
const StudentUnpaidsTotal = lazy(
  () =>
    import(
      "./modules/analytics/containers/studentUnpaidsTotal/StudentUnpaidsTotal"
    )
);
const Different = lazy(
  () => import("./modules/analytics/containers/different/Different")
);

const RoomsAnalitics = lazy(
  () => import("./modules/analytics/containers/rooms/Rooms")
);
const EarnedAnalytics = lazy(
  () => import("./modules/analytics/containers/EarnedAnalytics/EarnedAnalytics")
);
const AttendanceCancelledAnalytics = lazy(
  () => import("./modules/analytics/containers/attendanceCancelledAnalytics/AttendanceCancelled")
);


const SmsAnalitics = lazy(() => import("./modules/news/components/sms/Sms"));
const MonitoringStats = lazy(() => import("./modules/monitoring/statistics"));
const Statistics = lazy(() => import("./modules/statistics"));
const MonitoringFinance = lazy(() => import("./modules/monitoring/finance"));
const SmsDetails = lazy(
  () => import("./modules/news/components/smsDetails/SmsDetails")
);
const OnlineCourse = lazy(() => import("./newPages/onlineCourse/course/list"));
const CourseClient = lazy(
  () => import("./newPages/onlineCourse/course/clients/container")
);
const ClientAnswer = lazy(
  () => import("./newPages/onlineCourse/course/clientAnswer/container")
);
const AddOnlineCourse = lazy(
  () => import("./newPages/onlineCourse/course/add/container")
);
const Category = lazy(
  () => import("./newPages/onlineCourse/category/Category")
);

const SubCategories = lazy(
  () => import("./newPages/onlineCourse/subCategory/SubCategories")
);

export interface IRoute {
  private: boolean;
  component?: React.ExoticComponent;
  path: string;
  exact?: boolean;
  name?: string;
  id?: any;
  breadcrumb?: any;
  child?: any;
  showKey?: string;
}
export const routes: Array<IRoute> = [
  //! TASKS

  {
    private: true,
    component: TasksList,
    path: "/tasks/list",
    name: "COURSE_CREATE",
    id: "getEmployeeTask",
    showKey: "employeeTask",
    breadcrumb: [
      {
        path: "/tasks/list",
        value: "TASKS",
      },
    ],
  },
  {
    private: true,
    component: TasksTypeList,
    path: "/tasks/type-list",
    name: "COURSE_CREATE",
    id: "getEmployeeTask",
    showKey: "employeeTask",
  },
  {
    private: true,
    component: TasksSettings,
    path: "/tasks/settings",
    exact: false,
    name: "COURSE_CREATE",
    id: "getTask",
    showKey: "",
    breadcrumb: [
      {
        path: "/tasks/list",
        value: "TASKS",
      },
    ],
  },

  //! LEADS

  {
    private: true,
    component: OrderTableInfo,
    path: "/orders/order-list/edit/:id/:orderId",
    name: "UPDATE_ORDER",
    id: "updateOrder",
    showKey: "orders",
    breadcrumb: [
      {
        path: "/orders/order-list",
        value: "ORDER_LIST",
      },
      {
        path: "/orders/order-list/edit/:id/:orderId",
        value: "ORDER_DETAIL",
      },
    ],
  },
  {
    private: true,
    component: Kanban,
    path: "/orders/order-list/kanban",
    name: "ORDER_LIST",
    id: "getOrder",
    showKey: "orders",
    breadcrumb: [
      {
        path: "/orders/order-list",
        value: "ORDER_LIST",
      },
    ],
  },
  {
    private: true,
    component: KanbanColumnEdit,
    path: "/orders/order-list/kanban/column-edit",
    name: "ORDER_LIST",
    id: "getOrder",
    showKey: "orders",
    breadcrumb: [
      {
        path: "/orders/order-list",
        value: "ORDER_LIST",
      },
    ],
  },
  {
    private: true,
    component: OrderList,
    path: "/orders/order-list/table",
    name: "ORDER_LIST",
    id: "getOrder",
    showKey: "orders",
    breadcrumb: [
      {
        path: "/orders/order-list",
        value: "ORDER_LIST",
      },
    ],
  },
  {
    private: true,
    component: OrderInfo,
    path: "/orders/info/:id",
    name: "ORDER_LIST",
    id: "getOrder",
    showKey: "orders",
  },
  {
    private: true,
    component: OrderInfo,
    path: "/orders/add",
    name: "ORDER_LIST",
    id: "getOrder",
    showKey: "orders",
  },

  //! GROUP
  {
    private: true,
    component: GroupStudentCalculator,
    path: "/group/student-total-price/:id",
    name: "PARENT",
    id: "getArchiveStudents",
    showKey: "group",
  },

  {
    private: true,
    component: HistoryGroup,
    path: "/group/groups/history/:id",
    name: "GROUP",
    id: "getArchiveStudents",
    showKey: "group",
    breadcrumb: [
      {
        path: "/group/groups",
        value: "GROUP_LIST",
      },
      {
        path: "/group/groups/history/:id",
        value: "GROUP_HISTORY_DETAILS",
      },
    ],
  },
  {
    private: true,
    component: AttendanceGroup,
    path: "/group/groups/attendance/:id",
    name: "ATTENDANCE",
    id: "getGroupAttendance",
    showKey: "group",
    breadcrumb: [
      {
        path: "/group/groups",
        value: "GROUP_LIST",
      },
      {
        path: "/group/groups/details/:id",
        value: "GROUP_DETAIL",
      },
      {
        path: "/group/groups/attendance/:id",
        value: "GROUP_ATTENDANCE_DETAIL",
      },
    ],
  },
  {
    private: true,
    component: GroupDetails,
    path: "/group/groups/details/:id",
    name: "GROUP",
    id: "getGroup",
    showKey: "group",
    breadcrumb: [
      {
        path: "/group/groups",
        value: "GROUP_LIST",
      },
      {
        path: "/group/groups/details/:id",
        value: "GROUP_DETAIL",
      },
    ],
  },
  {
    private: true,
    component: GroupStudentsTemplate,
    path: "/group/groups/student/template/:groupId",
    name: "GROUP",
    id: "importGroupStudents",
    showKey: "group",
    breadcrumb: [
      {
        path: "/group/groups",
        value: "GROUP_LIST",
      },
      {
        path: "/group/groups/student/template/:groupId",
        value: "GROUP_STUDENT_TEMPLATE_IMPORT",
      },
    ],
  },
  {
    private: true,
    component: Groups,
    path: "/group/groups",
    name: "GROUP",
    id: "getGroup",
    showKey: "group",
    breadcrumb: [
      {
        path: "/group/groups",
        value: "GROUP_LIST",
      },
    ],
  },
  {
    private: true,
    component: GroupStudents,
    path: "/group/group-students",
    name: "GROUP_STUDENTS",
    id: "getGroupStudents",
    showKey: "group",
  },

  {
    private: true,
    component: GroupTasks,
    path: "/group/tasks",
    name: "GROUP_EXAMS",
    id: "getGroup",
    showKey: "group",
  },

  {
    private: true,
    component: GroupTaskAnswers,
    path: "/group/task-answers/:id",
    name: "GROUP_TASK_ANSWERS",
    id: "getGroup",
    showKey: "group",
  },

  {
    private: true,
    component: GroupsTemplate,
    path: "/group/groups/template",
    name: "GROUP",
    id: "importGroups",
    showKey: "group",
    breadcrumb: [
      {
        path: "/group/groups",
        value: "GROUP_LIST",
      },
      {
        path: "/group/groups/template",
        value: "GROUP_IMPORT_TEMPLATE",
      },
    ],
  },
  {
    private: true,
    component: TimeTable,
    path: "/group/class-schedule",
    name: "CLASS_SCHEDULE",
    id: "getTimetable",
    showKey: "group",
    breadcrumb: [
      {
        path: "/group/class-schedule",
        value: "TIME_TABLE",
      },
    ],
  },
  {
    private: true,
    component: Rooms,
    path: "/group/rooms",
    name: "ROOMS",
    id: "getRoom",
    showKey: "group",
    breadcrumb: [
      {
        path: "/group/rooms",
        value: "ROOM_LIST",
      },
    ],
  },

  //! STUDENTS

  {
    private: true,
    component: NewStudentList,
    path: "/orders/new-student-list",
    name: "NEW_STUDENT_LIST",
    id: "getNewStudents",
    showKey: "orders",
    breadcrumb: [
      {
        path: "/orders/new-student-list",
        value: "NEW_STUDENT_LIST",
      },
    ],
  },

  {
    private: true,
    component: StudentHistory,
    path: "/students/history/:id",
    name: "ARCHIVE",
    id: "getStudentHistory",
    showKey: "student",
    breadcrumb: [
      {
        path: "/students/history",
        value: "STUDENT_ARCHIVE",
      },
      {
        path: "/students/history/:id",
        value: "STUDENT_ARCHIVE_DETAILS",
      },
    ],
  },

  {
    private: true,
    component: StudentBalanceHistory,
    path: "/students/balance-history/:id",
    name: "ARCHIVE",
    id: "getStudentTransactions",
    showKey: "student",
  },

  {
    private: true,
    component: Details,
    path: "/students/student-list/edit/:id",
    name: "STUDENT",
    id: "updateStudent",
    showKey: "student",
    breadcrumb: [
      {
        path: "/students/student-list",
        value: "STUDENT_LIST",
      },
      {
        path: "/students/student-list/edit/:id",
        value: "STUDENT_DETAILS",
      },
    ],
  },
  {
    private: true,
    component: StudentList,
    path: "/students/student-list",
    name: "STUDENT",
    id: "getStudent",
    showKey: "student",
    breadcrumb: [
      {
        path: "/students/student-list",
        value: "STUDENT_LIST",
      },
    ],
  },
  {
    private: true,
    component: StudentsTemplate,
    path: "/students/student-list/template",
    name: "STUDENT",
    id: "importStudents",
    showKey: "student",
    breadcrumb: [
      {
        path: "/students/student-list",
        value: "STUDENT_LIST",
      },
      {
        path: "/students/student-list/template",
        value: "STUDENT_TEMPLATE_IMPORT",
      },
    ],
  },
  {
    private: true,
    component: Attendance,
    path: "/students/attendance",
    name: "ATTENDANCE",
    id: "getStudentAttendance",
    showKey: "student",
    breadcrumb: [
      {
        path: "/students/attendance",
        value: "STUDENT_ATTENDANCE",
      },
    ],
  },
  {
    private: true,
    component: AttendancesViewing,
    path: "/students/attendance/viewing",
    name: "ATTENDANCE",
    id: "getStudentAttendance",
    showKey: "student",
  },

  {
    private: true,
    component: Activ,
    path: "/students/active",
    name: "ACTIVE",
    id: "getActiveStudents",
    showKey: "student",
    breadcrumb: [
      {
        path: "/students/active",
        value: "STUDENT_ACTIVE",
      },
    ],
  },
  {
    private: true,
    component: Arxiv,
    path: "/students/archive",
    name: "ARCHIVE",
    id: "getArchiveStudents",
    showKey: "student",
    breadcrumb: [
      {
        path: "/students/archive",
        value: "STUDENT_ARCHIVE",
      },
    ],
  },

  {
    private: true,
    component: ComingSameDayOfWeek,
    path: "/students/coming-same-of-week",
    name: "COMING_OF_WEEK",
    id: "getActiveStudents",
    showKey: "student",
  },

  {
    private: true,
    component: Parents,
    path: "/students/parent",
    name: "PARENT",
    id: "getStudentParents",
    showKey: "student",
    breadcrumb: [
      {
        path: "/students/parent",
        value: "STUDENT_PARENTS",
      },
    ],
  },


  // Gamification

  {
    private: true,
    component: Products,
    path: "/gamification/products",
    name: "BONUS",
    id: "getProduct",
    showKey: "gamification",
  },
  {
    private: true,
    component: Categories,
    path: "/gamification/categories",
    name: "BONUS",
    id: "getProductCategory",
    showKey: "gamification",
  },
  {
    private: true,
    component: Orders,
    path: "/gamification/orders",
    name: "BONUS",
    id: "getProductOrder",
    showKey: "gamification",
  },
  {
    private: true,
    component: Reasons,
    path: "/gamification/reasons",
    name: "BONUS",
    id: "getProduct",
    showKey: "gamification",
  },
  // {
  //   private: true,
  //   component: RankingList,
  //   path: "/gamification/ranking-list",
  //   name: "BONUS",
  //   id: "bonus",
  //   showKey: "finance",
  // },
  // {
  //   private: true,
  //   component: CoinSettings,
  //   path: "/gamification/coin-settings",
  //   name: "BONUS",
  //   id: "bonus",
  //   showKey: "finance",
  // },

  //! STUDY_DEPARTMENT
  {
    private: true,
    component: AddLevel,
    path: "/course/courses/level-edit/:id",
    name: "COURSE_LEVEL_UPDATE",
    id: "getCourse",
    showKey: "course",
    breadcrumb: [
      {
        path: "/course/courses",
        value: "COURSES_LIST",
      },
      {
        path: "/course/details/:id",
        value: "COURSES_DETAILS",
      },
      {
        path: "/course/courses/level-edit/:id",
        value: "COURSE_LEVEL_UPDATE",
      },
    ],
  },
  {
    private: true,
    component: AddLevel,
    path: "/course/courses/level-add/:id",
    name: "COURSE_LEVEL_CREATE",
    id: "getCourse",
    showKey: "course",
    breadcrumb: [
      {
        path: "/course/courses",
        value: "COURSES_LIST",
      },
      {
        path: "/course/details/:id",
        value: "COURSES_DETAILS",
      },
      {
        path: "/course/courses/level-add/:id",
        value: "COURSE_LEVEL_CREATE",
      },
    ],
  },
  {
    private: true,
    component: AddCourse,
    path: "/course/courses/add",
    name: "COURSE_CREATE",
    id: "createCourse",
    showKey: "course",
    breadcrumb: [
      {
        path: "/course/courses",
        value: "COURSES_LIST",
      },
      {
        path: "/course/courses/add",
        value: "COURSE_CREATE",
      },
    ],
  },
  {
    private: true,
    component: AddCourse,
    path: "/course/courses/edit/:id",
    name: "COURSE_UPDATE",
    id: "updateCourse",
    showKey: "course",
    breadcrumb: [
      {
        path: "/course/courses",
        value: "COURSES_LIST",
      },
      {
        path: "/course/courses/edit/:id",
        value: "COURSE_UPDATE",
      },
    ],
  },
  {
    private: true,
    component: CourseList,
    path: "/course/courses",
    name: "COURSES",
    id: "getCourse",
    showKey: "course",
    breadcrumb: [
      {
        path: "/course/courses",
        value: "COURSES_LIST",
      },
    ],
  },
  {
    private: true,
    component: CoursesTemplate,
    path: "/course/courses/template",
    name: "COURSES",
    id: "importCourses",
    showKey: "course",
    breadcrumb: [
      {
        path: "/course/courses",
        value: "COURSES_LIST",
      },
      {
        path: "/course/courses/template",
        value: "COURSES_IMPORT_TEMPLATE",
      },
    ],
  },
  {
    private: true,
    component: CourseDetails,
    path: "/course/details/:id",
    name: "COURSE_DETAILS",
    id: "getCourse",
    showKey: "course",
    breadcrumb: [
      {
        path: "/course/courses",
        value: "COURSES_LIST",
      },
      {
        path: "/course/details/:id",
        value: "COURSE_DETAILS",
      },
    ],
  },
  {
    private: true,
    component: SectionsPage,
    path: "/course/sections",
    name: "SECTION",
    id: "getSection",
    showKey: "course",
    breadcrumb: [
      {
        path: "/course/sections",
        value: "SECTION",
      },
    ],
  },

  {
    private: true,
    component: OnlineCourse,
    path: "/online-course",
    name: "ONLINE_COURSE",
    id: "createOnlineCourse",
    showKey: "onlineCourse",
    breadcrumb: [
      {
        path: "/online-course",
        value: "ONLINE_COURSE",
      },
    ],
  },
  {
    private: true,
    component: CourseClient,
    path: "/online-course/clients/:id",
    name: "ONLINE_COURSE",
    id: "getOnlineCourseActives",
    showKey: "onlineCourse",
    breadcrumb: [
      {
        path: "/online-course",
        value: "ONLINE_COURSE",
      },
    ],
  },
  {
    private: true,
    component: ClientAnswer,
    path: "/online-course/clients/:id/:clientId",
    name: "ONLINE_COURSE",
    id: "getOnlineCourseActives",
    showKey: "onlineCourse",
    breadcrumb: [
      {
        path: "/online-course",
        value: "ONLINE_COURSE",
      },
    ],
  },
  {
    private: true,
    component: AddOnlineCourse,
    path: "/online-course/add",
    name: "ONLINE_COURSE",
    id: "createOnlineCourse",
    showKey: "onlineCourse",
    breadcrumb: [
      {
        path: "/online-course",
        value: "ONLINE_COURSE",
      },
      {
        path: "/online-course/add",
        value: "ONLINE_COURSE",
      },
    ],
  },
  {
    private: true,
    component: Category,
    path: "/online-course-category",
    name: "ONLINE_COURSE_CATEGORY",
    id: "getOnlineCourseCategory",
    showKey: "onlineCourse",
    breadcrumb: [
      {
        path: "/online-course-category",
        value: "ONLINE_COURSE_CATEGORY",
      },
    ],
  },
  {
    private: true,
    component: SubCategories,
    path: "/online-course-category/:onlineCategoryId",
    name: "ONLINE_COURSE_CATEGORY",
    id: "getOnlineCourseCategory",
    showKey: "employeeTask",
    breadcrumb: [
      {
        path: "/online-course-category",
        value: "ONLINE_COURSE_CATEGORY",
      },
    ],
  },
  {
    private: true,
    component: SeasonalAssessment,
    path: "/seasonal-assessment",
    name: "SEASONAL_ASSESSMENT",
    id: "getSeasonalMarks", // must change
    showKey: "_id", // must change
  },
  {
    private: true,
    component: AddSeasonalAssessment,
    path: "/seasonal-assessment/add",
    name: "SEASONAL_ASSESSMENT",
    id: "getSeasonalMarks", // must change
    showKey: "_id", // must change
    // breadcrumb: [
    //   {
    //     path: "/online-course",
    //     value: "ONLINE_COURSE",
    //   },
    //   {
    //     path: "/online-course/add",
    //     value: "ONLINE_COURSE",
    //   },
    // ],
  },
  {
    private: true,
    component: TestLevel,
    path: "/test-level",
    name: "TEST_LEVEL",
    id: "getSeasonalMarks", // must change
    showKey: "_id", // must change
  },
  {
    private: true,
    component: Test,
    path: "/test",
    name: "TEST",
    id: "getSeasonalMarks", // must change
    showKey: "_id", // must change
  },

  {
    private: true,
    component: SectionList,
    path: "/new-course/new-sections",
    name: "COURSE_CREATE",
    id: "createCourse",
    showKey: "",
    breadcrumb: [
      {
        path: "/course/courses",
        value: "COURSES_LIST",
      },
      {
        path: "/course/courses/add",
        value: "COURSE_CREATE",
      },
    ],
  },

  // !FINANCE

  {
    private: true,
    component: ShiftsHistory,
    path: "/finance/shifts/history",
    name: "HISTORY",
    id: "shiftHistory",
    showKey: "finance",
    breadcrumb: [
      // {
      //   path: "/finance/shifts",
      //   value: "SHIFT",
      // },
      {
        path: "/finance/cash",
        value: "CASH_DESK",
      },
      {
        path: "/finance/shifts/history",
        value: "SHIFT_HISTORY",
      },
    ],
  },
  {
    private: true,
    component: CheckHistory,
    path: "/finance/shifts/history/check/:id",
    name: "HISTORY",
    id: "shiftHistory",
    showKey: "finance",
    breadcrumb: [
      {
        path: "/finance/cash",
        value: "CASH_DESK",
      },
      {
        path: "/finance/shifts/history",
        value: "SHIFT_HISTORY",
      },
      {
        path: "/finance/shifts/history/check/:id",
        value: "CHECK_HISTORY",
      },
    ],
  },
  {
    private: true,
    component: Management,
    path: "/finance/shifts/management/:id",
    name: "MANAGEMENT",
    id: "shift",
    showKey: "finance",
    breadcrumb: [
      {
        path: "/finance/shifts/management/:id",
        value: "MANAGEMENT_DETAILS",
      },
    ],
  },
  {
    private: true,
    component: PaymentTypeAdd,
    path: "/finance/payment-type/edit/:id",
    name: "PAYMENT",
    id: "updateShiftTransaction",
    showKey: "finance",
    breadcrumb: [
      {
        path: "/finance/payment-type",
        value: "PAYMENT_TYPE",
      },
      {
        path: "/finance/payment-type/edit/:id",
        value: "PAYMENT_TYPE_UPDATE",
      },
    ],
  },
  {
    private: true,
    component: PaymentTypeAdd,
    path: "/finance/payment-type/add",
    name: "PAYMENT",
    id: "createShiftTransaction",
    showKey: "finance",
    breadcrumb: [
      {
        path: "/finance/payment-type",
        value: "PAYMENT_TYPE",
      },
      {
        path: "/finance/payment-type/add",
        value: "PAYMENT_TYPE_CREATE",
      },
    ],
  },
  {
    private: true,
    component: PaymentType,
    path: "/finance/payment-type",
    name: "PAYMENT",
    id: "getShiftTransaction",
    showKey: "finance",
    breadcrumb: [
      {
        path: "/finance/payment-type",
        value: "PAYMENT_TYPE",
      },
    ],
  },
  {
    private: true,
    component: Bonus,
    path: "/finance/bonus",
    name: "BONUS",
    id: "bonus",
    showKey: "finance",
  },
  {
    private: true,
    component: Penalty,
    path: "/finance/penalty",
    name: "PENALTY",
    id: "penaltyGetAll",
    showKey: "finance",
  },
  {
    private: true,
    component: Invoice,
    path: "/finance/invoice",
    name: "INVOICE",
    id: "invoice",
    showKey: "finance",
  },
  {
    private: true,
    component: Contract,
    path: "/finance/contract",
    name: "BONUS",
    id: "getStudentContract",
    showKey: "finance",
  },

  {
    private: true,
    component: RepeaTableExpences,
    path: "/finance/repeatable-expences",
    name: "REPEA_TABLE_EXPENCES",
    id: "getRepeatableExpence",
    showKey: "finance",
  },

  {
    private: true,
    component: Balance,
    path: "/finance/balance",
    name: "SALARY_BALANCE",
    id: "getStudentContract",
    showKey: "finance",
  },

  //! CONTROL
  // put below Control pages

  {
    private: true,
    component: Statistics,
    path: "/statistics",
    name: "STATISTICS",
    id: "getSurvey",
    showKey: "marketing",
    breadcrumb: [
      {
        path: "/statistics",
        value: "STATISTICS",
      },
    ],
  },

  {
    private: false,
    component: LoginPage,
    path: "/",
    id: "test",
  },
  {
    private: false,
    component: SignVerify,
    path: "/sign-verify",
    id: "test",
  },
  {
    private: false,
    component: SignInWithPassword,
    path: "/sign-with-password",
    id: "test",
  },
  {
    private: false,
    component: SetPassword,
    path: "/password",
    id: "test",
  },
  {
    private: false,
    component: ForgetPassword,
    path: "/forget-password",
    id: "test",
  },
  {
    private: true,
    component: Home,
    path: "/home",
    name: "HOME",
    id: "home",
    showKey: "mainPage",
    breadcrumb: [
      {
        path: "/home",
        value: "HOME",
      },
    ],
  },
  {
    private: true,
    component: Finance,
    path: "/analytics/finance",
    name: "FINANCE",
    id: "getFinanceAnalitics",
    showKey: "analitics",
    breadcrumb: [
      {
        path: "/analytics/finance",
        value: "FINANCE",
      },
    ],
  },
  {
    private: true,
    component: Finance,
    path: "/reports/analytics/finance",
    name: "FINANCE",
    id: "getFinanceAnalitics",
    showKey: "analitics",
    breadcrumb: [
      {
        path: "/analytics/finance",
        value: "FINANCE",
      },
    ],
  },

  {
    private: true,
    component: Surveys,
    path: "/marketing/surveys",
    name: "SURVEY",
    id: "getSurvey",
    showKey: "marketing",
    breadcrumb: [
      {
        path: "/marketing/surveys",
        value: "SURVEY",
      },
    ],
  },
  {
    private: true,
    component: MarketingForm,
    path: "/marketing/form",
    name: "MARKETING_FORM",
    id: "getSurvey",
    showKey: "marketing",
  },
  {
    private: true,
    component: ActiveSession,
    path: "/active-session",
    name: "MARKETING_FORM",
    id: "_id",
    showKey: "settings",
  },
  {
    private: true,
    component: NotificationFunction,
    path: "/notification",
    name: "MARKETING_FORM",
    id: "_id",
    showKey: "settings",
  },
  {
    private: true,
    component: MarketingForm,
    path: "/marketing/form",
    name: "MARKETING_FORM",
    id: "getSurvey",
    showKey: "marketing",
  },
  {
    private: true,
    component: AddEditMarketingForm,
    path: "/marketing/form/:id",
    name: "ADD_EDIT_MARKETING_FORM",
    id: "getSurvey",
    showKey: "marketing",
  },
  {
    private: true,
    component: SurveysTemplate,
    path: "/marketing/surveys/template",
    name: "SURVEY",
    id: "getSurvey",
    showKey: "marketing",
    breadcrumb: [
      {
        path: "/marketing/surveys",
        value: "SURVEY",
      },
      {
        path: "/marketing/surveys/template",
        value: "SURVEY_TEMPLATE",
      },
    ],
  },
  {
    private: true,
    component: MonitoringStats,
    path: "/monitoring/statistics",
    name: "MONITORING",
    id: "getAnaliticsstatistics",
    showKey: "monitoring_statistic",
  },
  {
    private: true,
    component: MonitoringStats,
    path: "/reports/monitoring/statistics",
    name: "MONITORING",
    id: "getAnaliticsstatistics",
    showKey: "monitoring_statistic",
  },
  {
    private: true,
    component: MonitoringFinance,
    path: "/monitoring/finance",
    name: "STATISTICS",
    id: "isBoss",
    showKey: "monitoring",
  },
  {
    private: true,
    component: KommoIntegration,
    path: "/kommo-integration",
    name: "KOMMO_INTEGRATION",
    id: "isBoss",
    showKey: "settings",
  },
  {
    private: true,
    component: Order,
    path: "/analytics/order",
    name: "ORDER",
    id: "getOrderAnalitics",
    showKey: "analitics",
    breadcrumb: [
      {
        path: "/analytics/order",
        value: "ORDER",
      },
    ],
  },
  {
    private: true,
    component: OneOrderType,
    path: "/analytics/order/:id",
    name: "ORDER",
    id: "getOrderAnalitics",
    showKey: "analitics",
    breadcrumb: [
      {
        path: "/analytics/order",
        value: "ORDER",
      },
      {
        path: "/analytics/order/:id",
        value: "Details",
      },
    ],
  },

  {
    private: true,
    component: BalanceAnalytics,
    path: "/analytics/balance",
    name: "TEACHER_ANALITICS",
    id: "getFinanceAnalitics",
    showKey: "analitics",
  },
  // {
  //   private: true,
  //   component: LeftReasons,
  //   path: "/analytics/left-reasons",
  //   name: "LEFT_REASONS",
  //   id: "getOrderAnalitics",
  //   showKey: "analitics",
  // },
  {
    private: true,
    component: IncomePlan,
    path: "/analytics/income-plan",
    name: "INCOME_PLAN",
    id: "getFinanceAnalitics",
    showKey: "analitics",
  },
  {
    private: true,
    component: IncomePlan,
    path: "/reports/analytics/income-plan",
    name: "INCOME_PLAN",
    id: "getFinanceAnalitics",
    showKey: "analitics",
  },
  {
    private: true,
    component: NotAttended,
    path: "/analytics/not-attended",
    name: "NOT_ATTENDED",
    id: "getOrderAnalitics",
    showKey: "analitics",
  },
  {
    private: true,
    component: NotAttended,
    path: "/reports/analytics/not-attended",
    name: "NOT_ATTENDED",
    id: "getOrderAnalitics",
    showKey: "analitics",
  },
  {
    private: true,
    component: AttendanceAnalytics,
    path: "/analytics/attendance",
    name: "ATTENDANCE",
    id: "getOrderAnalitics",
    showKey: "analitics",
  },
  {
    private: true,
    component: StudentUnpaidsTotal,
    path: "/analytics/unpaid",
    name: "UNPAIDS_TOTAL",
    id: "getOrderAnalitics",
    showKey: "analitics",
  },
  {
    private: true,
    component: StudentUnpaidsTotal,
    path: "/reports/analytics/unpaid",
    name: "UNPAIDS_TOTAL",
    id: "getOrderAnalitics",
    showKey: "analitics",
  },
  {
    private: true,
    component: Different,
    path: "/analytics/different",
    name: "DIFFERENT",
    id: "getOrderAnalitics",
    showKey: "analitics",
  },
  {
    private: true,
    component: Different,
    path: "/reports/analytics/different",
    name: "DIFFERENT",
    id: "getOrderAnalitics",
    showKey: "analitics",
  },

  {
    private: true,
    component: RoomsAnalitics,
    path: "/analytics/rooms",
    name: "ROOMS",
    id: "getOrderAnalitics",
    showKey: "analitics",
  },
  {
    private: true,
    component: EarnedAnalytics,
    path: "/analytics/earned-analytics",
    name: "TEACHER_SALARY",
    id: "getOrderAnalitics",
    showKey: "analitics",
  },
  {
    private: true,
    component: AttendanceCancelledAnalytics,
    path: "/analytics/attendance-cancelled-analytics",
    name: "ATTENDANCE_CANCELLED",
    id: "getOrderAnalitics",
    showKey: "analitics",
  },
  {
    private: true,
    component: CancelledTransactions,
    path: "/analytics/cancelled-transactions",
    name: "CANCELLED_TRANSACTION",
    id: "getFinanceAnalitics",
    showKey: "analitics",
  },
  {
    private: true,
    component: GeneralDiscounts,
    path: "/analytics/general-discounts",
    name: "CANCELLED_TRANSACTION",
    id: "getFinanceAnalitics",
    showKey: "analitics",
  },
  {
    private: true,
    component: TaskAnswerByTeacher,
    path: "/analytics/task-answers-by-teacher",
    name: "TASK_ANSWERS_BY_TEACHER",
    id: "getOrderAnalitics",
    showKey: "analitics",
  },
  {
    private: true,
    component: CashflowAnalytics,
    path: "/analytics/cashflow",
    name: "TEACHER_ANALITICS",
    id: "getFinanceAnalitics",
    showKey: "analitics",
  },
  {
    private: true,
    component: ProfitLossAnalytics,
    path: "/analytics/profit-loss",
    name: "TEACHER_ANALITICS",
    id: "getFinanceAnalitics",
    showKey: "analitics",
  },
  {
    private: true,
    component: AnalyticsLinks,
    path: "/analytics",
    name: "TEACHER_ANALITICS",
    id: "getAllAnalitics",
    showKey: "analitics",
  },
  {
    private: true,
    component: TeacherAnalitics,
    path: "/analytics/teacher",
    name: "TEACHER_ANALITICS",
    id: "getOrderAnalitics",
    showKey: "analitics",
  },
  {
    private: true,
    component: TeacherAnaliticsDetails,
    path: "/analytics/teacher/:id",
    name: "TEACHER_ANALITICS",
    id: "getOrderAnalitics",
    showKey: "analitics",
  },
  {
    private: true,
    component: Moderator,
    path: "/analytics/moderator/student",
    name: "TEACHER_ANALITICS",
    id: "getOrderAnalitics",
    showKey: "analitics",
  },
  {
    private: true,
    component: ModeratorDetails,
    path: "/analytics/moderator/student/:id",
    name: "TEACHER_ANALITICS",
    id: "getOrderAnalitics",
    showKey: "analitics",
  },
  {
    private: true,
    component: StudentByCourse,
    path: "/analytics/course/student",
    name: "TEACHER_ANALITICS",
    id: "getOrderAnalitics",
    showKey: "analitics",
  },
  {
    private: true,
    component: StudentByCourseDetails,
    path: "/analytics/course/student/:id",
    name: "TEACHER_ANALITICS",
    id: "getOrderAnalitics",
    showKey: "analitics",
  },
  {
    private: true,
    component: OrderByCourse,
    path: "/analytics/course/order",
    name: "TEACHER_ANALITICS",
    id: "getOrderAnalitics",
    showKey: "analitics",
  },
  {
    private: true,
    component: OrderByCourseDetails,
    path: "/analytics/course/order/:id",
    name: "TEACHER_ANALITICS",
    id: "getOrderAnalitics",
    showKey: "analitics",
  },
  {
    private: true,
    component: OrderModerator,
    path: "/analytics/moderator/order",
    name: "TEACHER_ANALITICS",
    id: "getOrderAnalitics",
    showKey: "analitics",
  },
  {
    private: true,
    component: OrderModeratorDetails,
    path: "/analytics/moderator/order/:id",
    name: "TEACHER_ANALITICS",
    id: "getOrderAnalitics",
    showKey: "analitics",
  },
  {
    private: true,
    component: Questionnaire,
    path: "/analytics/questionnaire",
    name: "QUESTIONNAIRE_ANALYTICS",
    id: "getOrderAnalitics",
    showKey: "analitics",
  },
  {
    private: true,
    component: QuestionnaireDetails,
    path: "/analytics/questionnaire/:id",
    name: "QUESTIONNAIRE_ANALYTICS",
    id: "getOrderAnalitics",
    showKey: "analitics",
  },

  {
    private: true,
    component: ComeOrders,
    path: "/orders/come-orders",
    name: "COME_ORDER",
    id: "getComeOrder",
    showKey: "orders",
    breadcrumb: [
      {
        path: "/orders/come-orders",
        value: "COME_ORDER",
      },
    ],
  },

  {
    private: true,
    component: Balance,
    path: "/reports/finance/balance",
    name: "SALARY_BALANCE",
    id: "getStudentContract",
    showKey: "finance",
  },
  {
    private: true,
    component: SalaryCreate,
    path: "/finance/salary/create",
    name: "SALARY_BALANCE",
    id: "createEmployeeSalary",
    showKey: "finance",
  },
  {
    private: true,
    component: Salary,
    path: "/finance/salary",
    name: "SALARY",
    id: "createEmployeeSalary",
    showKey: "finance",
  },
  {
    private: true,
    component: SalaryTransaction,
    path: "/finance/salary/:id",
    name: "SALARY",
    id: "createEmployeeSalary",
    showKey: "finance",
  },

  {
    private: true,
    component: Chat,
    path: "/chats",
    name: "CHAT",
    id: "chat",
    showKey: "chat",
    breadcrumb: [],
  },
  {
    private: true,
    component: Chat,
    path: "/chats/:id",
    name: "CHAT",
    id: "chat",
    showKey: "chat",
    breadcrumb: [],
  },

  {
    private: true,
    component: Profile,
    path: "/hr/employees/profile/:id",
    name: "EMPLOYEES",
    id: "getEmployee",
    showKey: "employees",
    breadcrumb: [
      {
        path: "/hr/employees",
        value: "EMPLOYEE_LIST",
      },
      {
        path: "/hr/employees/profile/:id",
        value: "EMPLOYEE_DETAILS",
      },
    ],
  },
  {
    private: true,
    component: Hr,
    path: "/hr/employees",
    name: "EMPLOYEES",
    id: "getEmployee",
    showKey: "employees",
    breadcrumb: [
      {
        path: "/hr/employees",
        value: "EMPLOYEE_LIST",
      },
    ],
  },
  {
    private: true,
    component: Branches,
    path: "/branches",
    name: "BRANCHES",
    id: "getBranch",
    showKey: "employees",
    breadcrumb: [
      {
        path: "/hr/employees",
        value: "EMPLOYEE_LIST",
      },
    ],
  },
  {
    private: true,
    component: AddBranch,
    path: "/branches/add",
    name: "BRANCH",
    id: "getBranch",
    showKey: "employees",
    breadcrumb: [
      {
        path: "/settings/system",
        value: "SYSTEM",
      },
      {
        path: "/branches/add",
        value: "BRANCH_CREATE",
      },
    ],
  },
  {
    private: true,
    component: AddBranch,
    path: "/branches/edit/:id",
    name: "BRANCH",
    id: "updateBranch",
    showKey: "employees",
    breadcrumb: [
      {
        path: "/settings/system",
        value: "SYSTEM",
      },
      {
        path: "/branches/edit/:id",
        value: "BRANCH_UPDATE",
      },
    ],
  },
  {
    private: true,
    component: EmployeeRatings,
    path: "/hr/employees/ratings",
    name: "EMPLOYEES_RATINGS",
    id: "getTeacherLessonRates",
    showKey: "employees",
    breadcrumb: [
      {
        path: "/hr/employees",
        value: "EMPLOYEE_LIST",
      },
    ],
  },
  {
    private: true,
    component: EmployeeRatings,
    path: "/reports/hr/employees/ratings",
    name: "EMPLOYEES_RATINGS",
    id: "getTeacherLessonRates",
    showKey: "employees",
    breadcrumb: [
      {
        path: "/hr/employees",
        value: "EMPLOYEE_LIST",
      },
    ],
  },
  {
    private: true,
    component: EmployeesTemplate,
    path: "/hr/employees/template",
    name: "EMPLOYEES",
    id: "importTeachers",
    showKey: "employees",
    breadcrumb: [
      {
        path: "/hr/employees",
        value: "EMPLOYEE_LIST",
      },
      {
        path: "/hr/employees/template",
        value: "TEACHER_IMPORT_TEMPLATE",
      },
    ],
  },
  {
    private: true,
    component: AddRoles,
    path: "/hr/roles/add",
    name: "ROLES",
    id: "createRole",
    showKey: "employees",
    breadcrumb: [
      {
        path: "/hr/roles",
        value: "ROLE_LIST",
      },
      {
        path: "/hr/roles/add",
        value: "ROLE_CREATE",
      },
    ],
  },
  {
    private: true,
    component: AddRoles,
    path: "/hr/roles/edit/:id",
    name: "ROLE_UPDATE",
    id: "updateRole",
    showKey: "employees",
    breadcrumb: [
      {
        path: "/hr/roles",
        value: "ROLE_LIST",
      },
      {
        path: "/hr/roles/edit/:id",
        value: "ROLE_UPDATE",
      },
    ],
  },
  {
    private: true,
    component: Roles,
    path: "/hr/roles",
    name: "ROLES",
    id: "getRole",
    showKey: "employees",
    breadcrumb: [
      {
        path: "/hr/roles",
        value: "ROLE_LIST",
      },
    ],
  },
  {
    private: true,
    component: Feedback,
    path: "/feedback",
    name: "FEEDBACK",
    id: "feedback",
    showKey: "feedback",
  },
  {
    private: true,
    component: SettingSystem,
    path: "/settings/system",
    name: "SYSTEM",
    id: "settings",
    showKey: "settings",
    breadcrumb: [
      {
        path: "/settings/system",
        value: "SYSTEM",
      },
    ],
    child: [
      { id: "getReceipt" },
      { id: "getBranch" },
      { id: "getSurvey" },
      { id: "getOrderStatus" },
    ],
  },
  {
    private: true,
    component: AddEditThirdPerson,
    path: "/settings/system/third-person/add",
    name: "SYSTEM",
    id: "settings",
    showKey: "settings",
    breadcrumb: [
      {
        path: "/settings/system/third-person/add",
        value: "THIRD_PERSON",
      },
    ],
    child: [{ id: "getBranch" }],
  },
  {
    private: true,
    component: AddEditThirdPerson,
    path: "/settings/system/third-person/edit/:id",
    name: "SYSTEM",
    id: "settings",
    showKey: "settings",
    breadcrumb: [
      {
        path: "/settings/system/third-person/edit/:id",
        value: "THIRD_PERSON_EDIT",
      },
    ],
    child: [{ id: "getBranch" }],
  },
  {
    private: true,
    component: SettingsFinance,
    path: "/settings/finance",
    name: "MANAGER",
    id: "settings",
    showKey: "settings",
    breadcrumb: [
      {
        path: "/settings/finance",
        value: "MANAGER",
      },
    ],
    child: [{ id: "getOverpayment" }, { id: "getLevel" }],
  },
  {
    private: true,
    component: Study,
    path: "/settings/study",
    name: "STUDENT",
    id: "settings",
    showKey: "settings",
    breadcrumb: [
      {
        path: "/settings/study",
        value: "STUDENT",
      },
    ],
    child: [
      { id: "getOverpayment" },
      { id: "getTeacherSalary" },
      { id: "getLevel" },
    ],
  },
  {
    private: true,
    component: SaleMarketing,
    path: "/settings/sale-marketing",
    name: "AUTOSMS",
    id: "settings",
    showKey: "settings",
    breadcrumb: [
      {
        path: "/settings/sale-marketing",
        value: "AUTOSMS",
      },
    ],
    child: [{ id: "autosms" }, { id: "getSmsDevice" }],
  },

  {
    private: true,
    component: SettingManagement,
    path: "/settings/management",
    name: "MANAGE",
    id: "settings",
    showKey: "settings",
    breadcrumb: [
      {
        path: "/settings/management",
        value: "ACTIVITIES",
      },
    ],
    child: [
      { id: "getActivities" },
      { id: "getStudentBonus" },
      { id: "getStudentCategory" },
    ],
  },

  {
    private: true,
    component: BranchsTemplate,
    path: "/branches/template",
    name: "BRANCH",
    id: "getBranch",
    showKey: "settings",
    breadcrumb: [
      {
        path: "/settings/system",
        value: "SYSTEM",
      },
      {
        path: "branches/template",
        value: "BRANCH_TEMPLATE",
      },
    ],
  },

  {
    private: true,
    component: SmsAnalitics,
    path: "/news/sms",
    name: "NEWS",
    id: "getSms",
    showKey: "news",
  },
  {
    private: true,
    component: SmsDetails,
    path: "/news/sms/:id",
    name: "NEWS",
    id: "getSms",
    showKey: "news",
  },
  {
    private: true,
    component: News,
    path: "/news/news-list",
    name: "NEWS",
    id: "getNews",
    showKey: "news",
    breadcrumb: [
      {
        path: "/news/news-list",
        value: "NEWS_LIST",
      },
    ],
  },
  {
    private: true,
    component: AddNews,
    path: "/news/news-list/add",
    name: "NEWS",
    id: "createNews",
    showKey: "news",
    breadcrumb: [
      {
        path: "/news/news-list",
        value: "NEWS_LIST",
      },
      {
        path: "/news/news-list/add",
        value: "NEWS_CREATE",
      },
    ],
  },
  {
    private: true,
    component: AddNews,
    path: "/news/news-list/edit/:id",
    name: "NEWS",
    id: "updateNews",
    showKey: "news",
    breadcrumb: [
      {
        path: "/news/news-list",
        value: "NEWS_LIST",
      },
      {
        path: "/news/news-list/edit/:id",
        value: "NEWS_UPDATE",
      },
    ],
  },
  {
    private: true,
    component: SmsTemplate,
    path: "/news/sms-template",
    name: "SMS_TEMPLATE",
    id: "getSmsT",
    showKey: "news",
    breadcrumb: [
      {
        path: "/news/sms-template",
        value: "SMS_TEMPLATE",
      },
      {
        path: "/news/news-list/edit/:id",
        value: "NEWS_UPDATE",
      },
    ],
  },
  {
    private: true,
    component: FinanceCash,
    path: "/finance/cash",
    name: "FINANCE",
    id: "shift",
    showKey: "finance",
    breadcrumb: [
      {
        path: "/finance/cash",
        value: "CASH_DESK",
      },
    ],
  },
  {
    private: true,
    component: Integration,
    path: "/settings/integration",
    name: "INTEGRATION",
    id: "settings",
    showKey: "settings",
    breadcrumb: [
      {
        path: "/settings/integration",
        value: "INTEGRATION",
      },
    ],
    child: [{ id: "integration" }],
  },
  {
    private: true,
    component: Transactions,
    path: "/settings/integration/:id",
    name: "TRANSACTIONS",
    id: "settings",
    showKey: "settings",
    breadcrumb: [
      {
        path: "/settings/integration",
        value: "INTEGRATION",
      },
      {
        path: "/settings/integration/:id",
        value: "TRANSACTIONS",
      },
    ],
    child: [{ id: "integration" }],
  },

  {
    private: true,
    component: PageNotFound,
    path: "",
    id: "test",
  },
];
